import React from 'react'
import { EditorRoomName } from '../ui/editorComponents'
import DashboardCell from './dashboardCell'
import moment from 'moment'
import 'moment-range'
import classNames from 'classnames'
import _ from 'lodash'
import { connect } from 'react-redux'
import { openRoomDialog } from '../../redux/actions/dashboardActions'

// TODO: Make this more efficient than looping
const getEventsForDay = function(date, events, isFirst) {
  const matchFunc = event => date.isSame(event.checkInDate, 'day')
  const firstDayMatchFunc = event =>
    matchFunc(event) || date.isAfter(event.checkInDate)
  const matchFuncToUse = isFirst ? firstDayMatchFunc : matchFunc

  return _.filter(events, matchFuncToUse)
}

const DashboardRow = props => {
  const { room, datesToDisplay, events, cellContentFn, roomTransfer } = props

  const roomName = room.name
  const cells = []
  const cellWidth = (1 / (datesToDisplay.diff('days') + 1)) * 100 + '%'
  const maxLevel = _.max(_.map(events, 'level')) || 0
  const rowHeight = maxLevel === 0 ? '3.6em' : `${(maxLevel + 1) * 3}em`
  const today = new Date()

  datesToDisplay.by('days', date => {
    cells.push(date)
  })

  const lodgeClass = classNames('dashboard-lodge-name', {
    dirty: !room.isClean
  })

  return (
    <tr key={room.id}>
      <td
        className={lodgeClass}
        key={roomName}
        onClick={() => props.dispatch(openRoomDialog({ roomId: room.id }))}
      >
        {/* First checks if room gender if undefined, none, male or female  */}
        <div
          className={`dashboard-date-circle ${
            room.gender === undefined
              ? ''
              : room.gender === 'none'
              ? 'dashboard-date-circle-none'
              : room.gender === 'male'
              ? ' dashboard-date-circle-male'
              : ' dashboard-date-circle-female'
          }`}
        />{' '}
        <EditorRoomName room={room} />
      </td>
      <td className='dashboard-date-row-container'>
        <div
          className='dashboard-date-row'
          style={{ height: rowHeight, lineHeight: rowHeight }}
        >
          {cells.map((date, index) => (
            <DashboardCell
              key={index}
              date={date}
              visits={getEventsForDay(date, events, index === 0)}
              width={cellWidth}
              cellContentFn={cellContentFn}
              isToday={moment(date).isSame(today, 'day')}
              roomTransfer={roomTransfer}
            />
          ))}
        </div>
      </td>
    </tr>
  )
}

// Wrap the component to inject dispatch and state into it
export default connect()(DashboardRow)



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardRow.js